import React, { ReactNode } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Alert, Button } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { Linq } from '@src/components/Linq'
import { shoppingAiRoute } from '@src/routes'
import { sendEvent } from '@utils/analytics/coreAnalytics'

type ShoppingAiBannerProps = {
  alertMessage: ReactNode
  actionButtonText?: ReactNode
  gaSection?: string
}

const useStyles = makeStyles()((theme) => ({
  actionButton: {
    marginTop: theme.spacing(5),
    padding: theme.spacing(2, 6),
  },
  alertBanner: {
    backgroundColor: theme.palette.primary.light,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.common.black,
    justifyContent: 'center',
    padding: theme.spacing(3, 0),
    textAlign: 'center',
  },
}))

export const ShoppingAiBanner = ({
  actionButtonText,
  alertMessage,
  gaSection,
}: ShoppingAiBannerProps) => {
  const { classes } = useStyles()

  return (
    <Alert
      className={classes.alertBanner}
      data-testid="shopping-ai-banner"
      icon={false}
      variant="outlined"
      role="alert"
      aria-live="assertive"
    >
      {alertMessage}
      <Linq
        data-testid="shopping-ai-banner-action-button"
        href={shoppingAiRoute.index()}
      >
        <Button
          className={classes.actionButton}
          color="primary"
          variant="outlined"
          onClick={() => {
            sendEvent({
              payload: {
                event: 'ls_ai_interaction',
                action: 'open ai tool',
                detail: undefined,
                section: gaSection,
                component: 'body',
                element_type: 'button',
                element_text: actionButtonText || 'try it out',
                link_url: shoppingAiRoute.index(),
                core_event: 'no',
                user_detail: undefined,
                event_group: undefined,
                event_subgroup: undefined,
                product_id: undefined,
                product_brand: undefined,
              },
            })
          }}
          aria-label={actionButtonText ? `${actionButtonText}` : 'Try it out'}
        >
          {actionButtonText || (
            <FormattedMessage id="TRY_IT_OUT" defaultMessage="Try It Out" />
          )}
        </Button>
      </Linq>
    </Alert>
  )
}

export default ShoppingAiBanner
